module.exports = __webpack_public_path__ + "static/img/bohui_102@2x.14f3165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bohui_102@2x.png
// module id = 878
// module chunks = 1